import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCandidatesExtraInfoById } from '@modules/candidate-extra-info/store/candidate-extra-info.selectors';

@Component({
  selector: 'mojo-candidate-extra-info',
  templateUrl: './candidate-extra-info.component.html',
  styleUrls: ['./candidate-extra-info.component.scss'],
})
export class CandidateExtraInfoComponent implements OnInit {
  @Input() candidateId!: number;
  extraInfo$;

  constructor(private store: Store<{}>) {}

  ngOnInit() {
    this.extraInfo$ = this.store.select(selectCandidatesExtraInfoById(this.candidateId));
  }
  timedOutCloser;
  mouseEnter(trigger) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 500);
  }
}
